import { jsx as _jsx } from "react/jsx-runtime";
import { TemplateForm } from "@ploy-ui/template-form";
import { RoutePageProvider } from "../../components/RoutePageProvider";
export const renderTemplateWithRouteState = (props) => (_jsx(RoutePageProvider, { labelsWithEvents: props.template?.pages.map(p => ({
        label: (p.pageUri?.trim().length ?? 0) > 0 ? p.pageUri : p.pageTitle,
        gtmPageEvent: p.gtmPageEvent
    })) ?? [], children: _jsx(TemplateForm, { ...props }) }));
//# sourceMappingURL=renderTemplate.js.map